import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { AccordionClasses } from '@shared/accordion/accordion.config';

import { AccordionDirective } from './accordion.directive';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { NgClass, NgIf, NgStyle } from '@angular/common';

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AccordionDirective, NgClass, NgIf, SvgIconComponent, NgStyle]
})
export class AccordionComponent {
    public accordionClasses = AccordionClasses;

    @Input()
    public expanded: boolean = false;

    @Input()
    public adjustVelocity: boolean = false;

    @HostBinding('class.accordion--group-mode') public get isGroupMode(): boolean {
        return this.type === 'group';
    }

    @Input()
    public type: 'regular' | 'group' | 'menu' = 'regular';

    @Input()
    public id?: string;

    @Input()
    public contentWrapperStyle: Partial<CSSStyleDeclaration>;

    @Output()
    public expandChange = new EventEmitter<boolean>();

    @ViewChild(AccordionDirective)
    public accordion: AccordionDirective;

    public expand(): void {
        this.accordion.expand();
    }

    public collapse(): void {
        this.accordion.collapse();
    }
}
